import { getEwsRequestString, createDisplayDate } from 'owa-datetime';
import getOwaTimeZoneOffset from 'owa-datetime-store/lib/utils/getTimezoneOffset';
import { getEndDate } from '../selectors/getStoreProperties';
/**
 * Utility function to get end date time
 * @returns end date time from store
 */
export default function getEndDateTime() {
    var endDate = getEndDate();
    var endDateTime = null;
    if (endDate !== null) {
        var curEnd = endDate;
        var endHours = curEnd.getHours();
        var endMinutes = curEnd.getMinutes();
        var endYear = curEnd.getFullYear();
        var endMonth = curEnd.getMonth();
        var date = curEnd.getDate();
        // Set new end
        var newEnd = createDisplayDate(endYear, endMonth, date, endHours, endMinutes);
        /* Offset calculation and appending Z is a temporary fix to overcome the issue at server side
           Bug: 25483 to track the issue. Once resolved, we need to just call getEwsRequestString */
        var offset = getOwaTimeZoneOffset(endDate);
        newEnd.setMinutes(newEnd.getMinutes() - offset);
        endDateTime = getEwsRequestString(newEnd) + 'Z';
    }
    return endDateTime;
}
//# sourceMappingURL=getEndDateTime.js.map